import { ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

export function Blockquote({ children }: Props) {
  return <blockquote className="italic">"{children}"</blockquote>;
}
